import * as moment from 'moment';

/** Takes a date string and converts it to DD.MM.YYYY.  */
export function formatDate(dateString: string) {
  return moment(dateString).format('DD.MM.YYYY');
}

/** Checks whether target array has all the elements source array has. */
export function arrayContainsAnotherArray(sourceArray: any[], targetArray: any[]): boolean {
  for (const element of sourceArray) {
    if (targetArray.indexOf(element) === -1) {
      return false;
    }
  }
  return true;
}

/** Decodes encoded strings. For example "&" followed by "amp;" is decoded to & */
export function decodeHTML(html: string) {
  const parser = new DOMParser();
  const dom = parser.parseFromString('<!doctype html><body>' + html, 'text/html');
  return dom.body.textContent;
}



// WEBPACK FOOTER //
// ./src/tools/CommonFunctions.ts